import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ServiceHeader = () => {

  const company = useSelector((state) => state.companyReducer.company);
  const logo = company.logoLocation || "";

  const navigate = useNavigate();

  const handleAppointmentClick = () => {
    navigate("/appointment");
  };

  const handleSignupClick = () => {
    navigate("/sign-in");
  };

  const handleContactUsClick = () => {
    navigate("/contact-us");
  };

  const handleAboutUsClick = () => {
    navigate("/about-us");
  };

  return (
    <header
      className="bg-blue-500 text-white py-12 px-16 fixed safe-area-top left-0 right-0 z-50"
      style={{ backgroundColor: "#111827" }}
    >
      <div className="flex justify-between items-center">
        {/* Navigation Section */}
        <div className="flex items-center space-x-2">
          <img src={logo} alt="Company Logo" className="h-16 border-2 border-white" />
        </div>

        <nav className="flex items-center">
          <ul className="flex space-x-8 text-lg font-semibold">
            <li>
              <a
                href="/"
                className="hover:text-yellow-400 transition-all duration-300"
              >
                Home
              </a>
            </li>
            <li>
              <span
                onClick={handleAboutUsClick}
                className="hover:text-yellow-400 transition-all duration-300 cursor-pointer"
              >
                About Us
              </span>
            </li>
            <li>
              <span
                onClick={handleAboutUsClick}
                className="hover:text-yellow-400 transition-all duration-300 cursor-pointer"
              >
                Services
              </span>
            </li>
            <li>
              <span
                onClick={handleContactUsClick}
                className="hover:text-yellow-400 transition-all duration-300 cursor-pointer"
              >
                Contact Us
              </span>
            </li>
          </ul>
        </nav>

        <div className="flex items-center space-x-4">
          <button
            onClick={handleAppointmentClick}
            className="bg-yellow-400 text-blue-700 font-bold px-6 py-2 rounded hover:bg-yellow-500 transition-all duration-300"
          >
            Appointment
          </button>
          <button
            type="button"
            onClick={handleSignupClick}
            className="text-yellow-400 font-bold hover:text-yellow-500 transition-all duration-300 cursor-pointer"
          >
            Login
          </button>
        </div>
      </div>
    </header>
  );
};

export default ServiceHeader;
